import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#fff",
    maxHeight: "auto",
    paddingButtom: "10%",
    height: "100vh",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#5675D3",
    },
  },
  divPayung: {
    display: "none",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      justifyContent: "center",
    },
  },
  payung: {
    height: "15%",
    position: "absolute",
    marginTop: "6%",
    marginLeft: "-8%",
  },
  gelombang: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  houseToko: {
    width: "100%",
    bottom: 0,
    position: "absolute",
  },
  content: {
    display: "flex",
    textAlign: "center",
    justifyContent: "center",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      textAlign: "center",
      marginLeft: "60%",
    },
    [theme.breakpoints.down("951")]: {
      marginLeft: 0,
    },
  },
  boxContent: {
    backgroundColor: "#fff",
    width: "550px",
    height: "auto",
    marginTop: "12%",

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      width: "450px",
      height: "auto",
      // marginTop: "-5%",
      marginRight: "20%",
      borderRadius: "5px",
      boxShadow: "0px 6px 6px #726e6e73",
    },
    [theme.breakpoints.down("951")]: {
      marginRight: 0,
      marginTop: "5%",
    },
  },
  textContent: {
    fontSize: "20px",
    textAlign: "center",
    marginTop: "20%",

    [theme.breakpoints.up("tablet")]: {
      fontSize: "20px",
      textAlign: "center",
      marginTop: "20%",
    },
  },
  textContent1: {
    fontWeight: "500",
  },
  textContent2: {
    color: "#5675D3",
  },
  textContent3: {
    backgroundColor: "#fff",
    display: "inline-block",
    width: "50%",
    fontSize: 18,

    [theme.breakpoints.up("tablet")]: {
      backgroundColor: "#fff",
      display: "inline-block",
      width: "50%",
      fontSize: 14,
      marginBottom: 10,
    },
  },
  garisContent: {
    height: 1,
    width: "2",
    backgroundColor: "grey",
    marginTop: -20,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 30,

    [theme.breakpoints.up("tablet")]: {
      height: 1,
      // width: "1",
      backgroundColor: "grey",
      marginTop: -40,
      marginLeft: 20,
      marginRight: 20,
      marginBottom: 30,
    },
  },
  textContent4: {
    marginTop: 15,
    marginBottom: 10,
    fontSize: "18px",

    [theme.breakpoints.up("tablet")]: {
      marginBottom: 20,
    },
  },
  form: {
    marginTop: 90,
    width: "70%",
  },
  textCopyright: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30%",

    [theme.breakpoints.up("tablet")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "1%",
    },
    [theme.breakpoints.down("1156")]: {
      fontSize: 0,
    },
  },
  textCopyrightH5: {
    color: "#0000",
    marginTop: 20,

    [theme.breakpoints.up("tablet")]: {
      color: "#fff",
      marginTop: 50,
    },
  },
  formBottom: {
    marginTop: 20,
    width: "90%",
    // height: "10%",
    marginBottom: "10px",

    [theme.breakpoints.up("tablet")]: {
      width: "90%",
      // height: "7%",
      marginBottom: "10px",
    },
  },
  formBottom1: {
    width: "90%",
    fontSize: 12,
    height: "10%",

    [theme.breakpoints.up("tablet")]: {
      width: "90%",
      height: "7%",
    },
  },
  inputTest: {
    padding: "",
    "& .MuiOutlinedInput-input": {
      padding: "14px",
      paddingLeft: "0",
    },
  },
}));
export default useStyles;
